/**
 * Sections de la landing adressables par une URL propre.
 *
 * Chaque entrée est à la fois une route (`path`, servie par `LandingPage`) et une
 * ancre DOM (`id`, la section vers laquelle on défile). Une seule source de vérité :
 * `App.tsx` en dérive les routes, `LandingPage` s'en sert pour savoir où défiler.
 *
 * Pourquoi de vraies routes plutôt que des `#ancres` : une URL de section doit
 * survivre au copier-coller. `vercel.json` réécrit tout vers `index.html`, donc
 * `/tarifs` tapé directement sert bien la landing, qui défile ensuite au bon endroit.
 */
export interface LandingSection {
  /** URL publique. En minuscules et sans accent : c'est ce qui s'affiche et se partage. */
  path: string;
  /** `id` de la section dans le DOM. Le décalage sous l'en-tête vient de son `scroll-mt-*`. */
  id: string;
}

export const LANDING_SECTIONS: LandingSection[] = [
  { path: '/produit', id: 'fonctionnalites' },
  { path: '/constat', id: 'constat' },
  { path: '/fonctionnement', id: 'fonctionnement' },
  { path: '/tarifs', id: 'tarifs' },
  { path: '/faq', id: 'faq' },
];
